import {
	FETCH_PHARMACY_PATIENT_DATA_REQUEST,
	FETCH_PHARMACY_PATIENT_DATA_SUCCESS,
	FETCH_PHARMACY_PATIENT_DATA_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const patientDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PHARMACY_PATIENT_DATA_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_PHARMACY_PATIENT_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case FETCH_PHARMACY_PATIENT_DATA_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default patientDataReducer